// extracted by mini-css-extract-plugin
export default {"header":"OffCanvasNav_header_pwGdT"};